import { createFileRoute, redirect } from "@tanstack/react-router"
import { buildSignInUrl } from "@/app/auth"

export const Route = createFileRoute("/login")({
    beforeLoad: ({ location }) => {
        throw redirect({
            href: buildSignInUrl(location.searchStr ? `/dashboard${location.searchStr}` : "/dashboard"),
            replace: true,
        })
    },
})
